<template>
    <div class="navbar-header d-xl-block d-none">
        <ul class="nav navbar-nav">
            <li class="nav-item">
                <b-link
                    class="navbar-brand"
                    to="/"
                >
                    <span class="brand-logo">
                        <b-img
                            :src="appLogoImage"
                            alt="logo"
                        />
                    </span>
                    <!-- <h2 class="brand-text mb-0">{{ appName }}</h2> -->
                    <!-- TODO: Descomentar lo de abajo si es necesario -->
                    <div class="nav align-items-center font-weight-bolder text-primary">{{ appName }}</div>
                </b-link>
            </li>
        </ul>
    </div>
</template>

<script>
import { getCompanyLogoUrl } from '@/assets'
import { getUserData } from '@/auth/utils'
import { $themeConfig } from '@themeConfig'
import { BLink, BImg } from 'bootstrap-vue'
import { computed } from 'vue'

export default {
    components: {
        BLink,
        BImg,
    },
    setup() {
        // App Name

        const appName = computed(() => (getUserData().empresa ? getUserData().empresa : $themeConfig.app.appName))

        const appLogoImage = computed(() => {
            return getCompanyLogoUrl()
        })

        return {
            appName,
            appLogoImage,
        }
    },
}
</script>

<style></style>
